import store from '../store'

// 路由后置 拦截器
export function afterEach(to, from) {

    //用于添加tab选项卡
    if (to.matched.length > 0) {
        var item = to.matched[to.matched.length - 1];
        //是二级路由
        if (item.parent && item.parent.components.default.name == "layout") {
            var tabs = store.state.app.tabs || [];
            //是否在tab历史列表中存在
            var index = tabs.findIndex((route) => { return route.fullPath == to.fullPath });
            //如果不存在，则添加当前路由，设置tab选中
            if (index == -1) {
                //不是首页
                if (to.name != "index") {

                    var tabsName = (tabs.length) + "";
                    var fromIndex = tabs.findIndex((route) => { return route.fullPath == from.fullPath });

                    //如果当前选项卡不是最后一个，则新打开的选项卡插入到当前之后
                    if (fromIndex != -1) {
                        store.commit("splice", ["app.tabs", fromIndex + 1, 0, to])
                        tabsName = (fromIndex + 1) + '';
                    } else {
                        store.commit("push", ["app.tabs", to])
                    }
                    store.commit("set", ["app.tabsName", tabsName])

                } else {
                    store.commit("set", ["app.tabsName", "index"]);
                }
            } else {
                store.commit("set", ["app.tabsName", index + ''])
            }
        }
    } else {
        // 没有找到 跳到404

    }
}